<template>
  <div class="d-flex gap-3 flex-wrap"
    v-if="viewdata.type == 'materialityrulevel' || viewdata.type == 'materialitygllevel' || viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type == 'bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'materialitysllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel'">
    
    <div class="status-card open">
      <h6 class="label font-weight-medium">
        {{ isMaterialityType ? `Total ${$nova.labelsName('approvals_page', 'commentary_cycle_label', 'Cycle')}(s)` : '' }}
      </h6>
      <h3 class="count">{{total_cycle ? total_cycle.length :  '-' }}</h3>
    </div>

    <div v-if="viewdata.stage >= 0 && viewdata.stage <= 2" class="status-card in-progress">
      <h6 class="label font-weight-medium">
        {{ isMaterialityType ? `Pending ${$nova.labelsName('approvals_page', 'commentary_cycle_label', 'Cycle')}(s)` : '' }}
      </h6>
      <h3 class="count">{{total_cycle && proccesed_cycle ? total_cycle.length - proccesed_cycle.length : '-' }}</h3>
    </div>

    <div v-else-if="viewdata.stage == -1" class="status-card rejected">
      <h6 class="label font-weight-medium">
        {{ isMaterialityType ? `Rejected ${$nova.labelsName('approvals_page', 'commentary_cycle_label', 'Cycle')}(s)` : '' }}
      </h6>
      <h3 class="count">{{total_cycle && proccesed_cycle ? total_cycle.length - proccesed_cycle.length : '-' }}</h3>
    </div>

    <div v-else-if="viewdata.stage == 3" class="status-card failed">
      <h6 class="label font-weight-medium">
        {{ isMaterialityType ? `Failed ${$nova.labelsName('approvals_page', 'commentary_cycle_label', 'RU Code')}` : '' }}
      </h6>
      <h3 class="count">{{total_cycle && proccesed_cycle ? total_cycle.length - proccesed_cycle.length : '-'}}</h3>
    </div>

    <div class="status-card approved">
      <h6 class="label font-weight-medium">
        {{ isMaterialityType ? `Processed ${$nova.labelsName('approvals_page', 'commentary_cycle_label', 'Cycle')}(s)` : '' }}
      </h6>
      <h3 class="count">{{proccesed_cycle ? proccesed_cycle.length : '-' }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalCycleStats',
  props: {
    viewdata: {
      type: Object,
      required: true
    },
    total_cycle: {
      type: Array,
      default: () => []
    },
    proccesed_cycle: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isMaterialityType() {
      const types = [
        'materialityrulevel', 'materialitygllevel', 'bulkmaterialityrulevel', 
        'filematerialityrulevel', 'bulkmaterialitygllevel', 'filematerialitygllevel', 
        'materialitysllevel', 'bulkmaterialitysllevel', 'filematerialitysllevel'
      ];
      return types.includes(this.viewdata.type);
    }
  }
}
</script>

<style scoped>
/* Status Card Styles */
.status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  background: #f7f7f7;
  border: 1px solid;
  min-width: 190px;
}

.status-card .label {
  white-space: nowrap;
  margin-right: 8px;
  margin-bottom: 0;
}

.status-card .count {
  font-weight: 600;
  margin-bottom: 0;
}

.status-card.open {
  border-color: var(--grey-900);
  background-color: var(--grey-50);
  color: var(--grey-900);
}

.status-card.approved {
  border-color: var(--status-green);
  color: var(--green-800);
  background-color: var(--green-50);
}

.status-card.rejected {
  border-color: var(--status-red);
  color: var(--red-600);
  background-color: var(--red-50);
}

.status-card.failed {
  border-color: var(--status-red);
  color: var(--red-600);
  background-color: var(--red-50);
}

.status-card.in-progress {
  border-color: var(--status-yellow);
  color: var(--yellow-600);
  background-color: var(--yellow-50);
}
</style>
